// Wrap in a function that initializes per section
function initAddSelectedProducts(sectionElement) {
  // Prevent double initialization
  if (sectionElement.dataset.addProductsInitialized) {
    return;
  }
  sectionElement.dataset.addProductsInitialized = 'true';

  sectionElement.addEventListener('click', function (event) {
    const button = event.target.closest('[data-add-selected-products]');

    // Only proceed if button was actually clicked
    if (!button) {
      return;
    }

    event.preventDefault();

    // Read discount code and force setting from button attributes
    const discountCode = button.getAttribute('data-discount-code');
    const forceDiscount = button.getAttribute('data-force-discount') === 'true';
    const showAlert = button.getAttribute('data-show-alert') === 'true';

    // Read attribute
    const raw = button.getAttribute('data-items');

    let items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      console.error('Invalid items JSON on add-selected-products button', e);
      return;
    }

    console.log('/discount/' + encodeURIComponent(discountCode))

    if ((!Array.isArray(items) || items.length === 0) && discountCode != '') {
      // Redirect first, then show alert after page loads
      sessionStorage.setItem('appliedDiscount', discountCode);
      window.location.href =  window.location.origin + '/discount/' + encodeURIComponent(discountCode);
      return;
    }

    if (!Array.isArray(items) || items.length === 0) {
      console.warn('No items to add – items array is empty:', items);
      return;
    }

    // First, get the current cart to check what's already there
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartItems = {};
        cart.items.forEach(item => {
          cartItems[item.variant_id] = item.quantity;
        });

        const itemsToAdd = [];
        const updates = {};

        items.forEach(item => {
          const variantId = item.id;
          const requestedQty = item.quantity || 1;

          if (cartItems[variantId]) {
            updates[variantId] = cartItems[variantId] + requestedQty;
          } else {
            itemsToAdd.push(item);
          }
        });

        const promises = [];

        if (Object.keys(updates).length > 0) {
          promises.push(
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ updates: updates })
            })
          );
        }

        if (itemsToAdd.length > 0) {
          promises.push(
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: itemsToAdd })
            })
          );
        }

        return Promise.all(promises);
      })
      .then(responses => {
        const allOk = responses.every(r => r.ok);
        if (!allOk) {
          console.error('Some cart operations failed');
          return;
        }

        // If showAlert is true, show cart notification and stay on page
        if (showAlert) {
          // Apply discount code to cart attributes if provided
          if (discountCode) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                attributes: { 'discount_code': discountCode }
              })
            })
            .then(() => {
              // Now show the cart notification
              fetch(`${window.Shopify.routes.root}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble`)
                .then(res => res.json())
                .then(sections => {
                  return fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                      const lastItem = cart.items[cart.items.length - 1];
                      const cartNotificationWrapper = document.querySelector('cart-notification');
                      if (cartNotificationWrapper && typeof cartNotificationWrapper.renderContents === 'function') {
                        cartNotificationWrapper.renderContents({
                          key: lastItem.key,
                          sections: sections
                        });

                        // AFTER rendering, update the links with discount code
                        setTimeout(() => {
                          const viewCartButton = document.querySelector('#cart-notification-button');
                          const checkoutForm = document.querySelector('#cart-notification-form');

                          if (viewCartButton) {
                            const currentHref = viewCartButton.getAttribute('href');
                            viewCartButton.setAttribute('href', currentHref + '?discount=' + encodeURIComponent(discountCode));
                          }

                          if (checkoutForm) {
                            const currentAction = checkoutForm.getAttribute('action');
                            checkoutForm.setAttribute('action', currentAction + '?discount=' + encodeURIComponent(discountCode));
                          }
                        }, 100);
                      }
                    });
                })
                .catch(err => console.error('Error showing cart notification:', err));
            })
            .catch(err => console.error('Error applying discount code:', err));
          } else {
            // No discount code, just show notification
            fetch(`${window.Shopify.routes.root}?sections=cart-notification-product,cart-notification-button,cart-icon-bubble`)
              .then(res => res.json())
              .then(sections => {
                return fetch('/cart.js')
                  .then(res => res.json())
                  .then(cart => {
                    const lastItem = cart.items[cart.items.length - 1];
                    const cartNotificationWrapper = document.querySelector('cart-notification');
                    if (cartNotificationWrapper && typeof cartNotificationWrapper.renderContents === 'function') {
                      cartNotificationWrapper.renderContents({
                        key: lastItem.key,
                        sections: sections
                      });
                    }
                  });
              })
              .catch(err => console.error('Error showing cart notification:', err));
          }

          return;
        }

        // Otherwise, redirect to cart/checkout with discount
        if (discountCode) {
          if (forceDiscount) {
            window.location.href = '/checkout?discount=' + encodeURIComponent(discountCode);
          } else {
            window.location.href = '/cart?discount=' + encodeURIComponent(discountCode);
          }
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(err => console.error('Error updating cart:', err));
  });
}

// Initialize for all video-slider sections on page load
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.video-slider-container').forEach(section => {
    initAddSelectedProducts(section);
  });
   const appliedDiscount = sessionStorage.getItem('appliedDiscount');
  if (appliedDiscount) {
    sessionStorage.removeItem('appliedDiscount');
    alert(appliedDiscount + ' has been applied to cart.');
  }
});
